module.exports = __webpack_public_path__ + "img/icon-dclshgz2.9cd6fb2f.png";